import React from 'react';
import SiteConstructor from 'app/edozvola/cases/construction-participants/site-constructor/site-constructor';
import SiteSupervisor from 'app/edozvola/cases/construction-participants/site-supervisor/site-supervisor';

const ConstructionParticipants = () => {
  return (
    <>
      <div className={'pb-4'}>
        <SiteConstructor />
      </div>
      <hr/>
      <div>
        <SiteSupervisor />
      </div>
    </>
  );
};

export default ConstructionParticipants;
